import type { CowryGeometryParams, GeometryConstraints } from "../core/types";
import { createRandomSource } from "../rng/rng";
import { cowryGeometryRanges } from "./cowryGeometryParams";

export function deriveGeometryParams(
  itemSeed: string,
  constraints: GeometryConstraints = cowryGeometryRanges,
): CowryGeometryParams {
  const random = createRandomSource(itemSeed).fork("geometry");
  return {
    shellLength: sample("shellLength"),
    shellWidth: sample("shellWidth"),
    shellHeight: sample("shellHeight"),
    dorsalBulge: sample("dorsalBulge"),
    endTaper: sample("endTaper"),
    ventralFlatness: sample("ventralFlatness"),
    ventralRecessWidth: sample("ventralRecessWidth"),
    ventralFoldCurve: sample("ventralFoldCurve"),
    longitudinalAsymmetry: sample("longitudinalAsymmetry"),
  };

  function sample(key: keyof CowryGeometryParams): number {
    const range = constraints[key];
    return random.range(range.min, range.max);
  }
}
